import { render } from "./SnehaSparshamApplicationList.vue?vue&type=template&id=a732a002&scoped=true"
import script from "./SnehaSparshamApplicationList.vue?vue&type=script&lang=js"
export * from "./SnehaSparshamApplicationList.vue?vue&type=script&lang=js"

import "./SnehaSparshamApplicationList.vue?vue&type=style&index=0&id=a732a002&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shuha\\Documents\\Wisdom guide front\\wg-frontend-v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a732a002"]])

export default __exports__